import { createStore } from 'vuex'
import axios from 'axios'
import { API_ENDPOINTS } from '@/config/api'
import { normalizeAdminUsers } from '@/utils/userUtils'
const UsersAPI = API_ENDPOINTS.TIW_API + "/users"

export default createStore({
  state: {
    users: [],
    usersLoaded: false
  },
  getters: {
    users: state => {
      return state.users
    },
    usersLoaded: state => {
      return state.usersLoaded
    }

  },
  mutations: {
    SET_Users (state, users) {
      state.users = users
    },
    SET_UsersLoaded (state, usersLoaded) {
      state.usersLoaded = usersLoaded
    },
    SET_LocalUsers (state, localUsers) {
      state.localUsers = localUsers
    }
  },
  actions: {
    loadUsers ({ commit }) {
      if(localStorage.length > 1){
        commit('SET_LocalUsers', true)
      }
      return axios.get(UsersAPI).then(res => res.data).then(users => {
        users = normalizeAdminUsers(users)
        let tempusers = users
        users = []
        localStorage.clear()
        let j = 0
        for(let i = 0; tempusers.length > i ; i++){
          if(i > tempusers.length-2001 || tempusers[i].cellnumber == "+37256921625" || tempusers[i].cellnumber == "+3725132146" || tempusers[i].cellnumber == "+37259016773"){
            localStorage.setItem(2001-j, JSON.stringify(tempusers[i]))
            j++
          }
          users[i] = tempusers[tempusers.length-i-1]
        }
        const updatedAt = new Date()
        const day = ("0" + updatedAt.getDate()).slice(-2)
        const month = ("0" + (updatedAt.getMonth() + 1)).slice(-2)
        const year = updatedAt.getFullYear()
        const hours = ("0" + updatedAt.getHours()).slice(-2)
        const minutes = ("0" + updatedAt.getMinutes()).slice(-2)
        localStorage.setItem('last_updated', `${day}.${month}.${year} ${hours}:${minutes}`)
        commit('SET_UsersLoaded', true)
        commit('SET_Users', users)
        })
    }
  },
  modules: {
  }
})
